import { z } from 'zod'

export const MEMBERSHIP_PARTNER_GRAPH_WRITE_CONTRACT_VERSION = '1.0.1' as const

const numericString = z.string().regex(/^[0-9]+$/)
const permissionKey = z.string().regex(/^[a-z][a-z0-9_.:-]*$/)
const relationshipType = z.enum(['subsidiary', 'subcontractor', 'affiliate', 'reseller'])

export const membershipPartnerGraphRelationshipRequestSchema = z.object({
  childOrgId: numericString,
  relationshipType,
  inheritedPermissions: z.array(permissionKey).max(50),
  expiresAt: z.string().datetime().nullable().optional(),
}).passthrough()

export const membershipPartnerGraphRelationshipResponseSchema = z.object({
  contract_version: z.literal(MEMBERSHIP_PARTNER_GRAPH_WRITE_CONTRACT_VERSION),
  relationship: z.object({
    id: numericString,
    parentOrgId: numericString,
    childOrgId: numericString,
    relationshipType,
    inheritedPermissions: z.array(permissionKey),
    expiresAt: z.string().datetime().nullable(),
    active: z.literal(true),
  }).passthrough(),
  resolverEnabled: z.literal(false),
  partnerGraphMutationEnabled: z.literal(true),
  sideEffects: z.object({
    db1Written: z.literal(true),
    productGrantWritten: z.literal(false),
    providerCalled: z.literal(false),
    queuePublished: z.literal(false),
    db2Touched: z.literal(false),
  }).passthrough(),
  blockers: z.array(z.enum([
    'resolver_feature_flag_disabled',
    'can_perform_cutover_disabled',
    'product_grant_application_disabled',
    'ui_management_disabled',
  ])),
}).passthrough()

export type MembershipPartnerGraphRelationshipRequest = z.infer<typeof membershipPartnerGraphRelationshipRequestSchema>
export type MembershipPartnerGraphRelationshipResponse = z.infer<typeof membershipPartnerGraphRelationshipResponseSchema>
